export class ProductStatus {
    constructor(options = {}) {
        this.elId = options.componentId;
        this.el = window[this.elId];
        this.status = options.status;
        this.storesModalTemplateSelector = options.storesModalTemplateSelector;

        this.productId = options.productId;
        this.product = null;

        if (!this.productId) {
            throw new Error('Не получен id товара');
        }

        this.initProduct();

        this.useStoresModal = options.useStoresModal ?? false;
        this.storesModalAdjacentSelector = options.storesModalAdjacentSelector;
        this.storesModal = null;
        if (this.useStoresModal) {
            this.initAmountModal();
        }

        this.amountTable = null;
        this.amountTableTemplateSelector = options.amountTableTemplateSelector;

        this.moveToTabSelector = options.moveToTabSelector;
        
        if(this.el) {
            this.el.addEventListener('click', this.onElementClick.bind(this));
        }
    }

    async initProduct() {
        this.product = await BX.Asteq.Catalog.Product.getInstanceAsync(this.productId);
        if (!this.product) {
            throw new Error('Не удалось найти продукт ' + this.productId);
        }

        this.product.subscribe('offerChange', this.onProductOfferChange.bind(this));
    }

    async initAmountModal() {
        if (!this.storesModalTemplateSelector) {
            return;
        }

        await BX.loadExt('asteq.modalabsolute');

        this.storesModal = new BX.Asteq.ModalAbsolute({
            templateSelector: this.storesModalTemplateSelector,
            buttonEl: this.el,
            storesModalAdjacentSelector: this.storesModalAdjacentSelector,
        });
    }

    setStatus(status) {
        const oldStatus = this.status;
        this.status = status;

        this.updateElement(oldStatus);
    }

    updateElement(oldStatus) {
        if (!this.el) {
            return;
        }

        const status = this.status;
        if (status) {
            this.el.style.display = null;
        } else {
            this.el.style.display = 'none';
        }

        if (oldStatus && oldStatus.CLASSES) {
            oldStatus.CLASSES.forEach((cls) => {
                this.el.classList.remove(cls);
            });
        }

        if (status.CLASSES) {
            status.CLASSES.forEach((cls) => {
                this.el.classList.add(cls);
            });
        }

        const statusTitleEl = this.el.querySelector('[data-status-title]');
        if (statusTitleEl && status.TITLE) {
            statusTitleEl.innerHTML = status.TITLE;
        }
    }

    async openStoresModal() {
        if (!this.useStoresModal) {
            return;
        }

        if (this.storesModal.isOpen()) {
            this.storesModal.close();
            return;
        }

        const product = this.product;
        if (!product) {
            console.error('Продукт не найден');
            return;
        }
        const offer = product.getCurrentOffer();
        this.storesModal.open();
        this.storesModal.setDetailLink(product.getUrl());


        await BX.loadExt('asteq.catalog.amounttable');

        if (!BX.Asteq?.ModalAbsolute && !BX.Asteq?.Catalog?.AmountTable) {
            console.error('Не удалось загрузить catalog.amounttable');
            return;
        }

        if (!this.amountTable) {
            const amountTableEl = this.storesModal.getContentBlock()?.querySelector('[data-modal-amount-table]');
            this.amountTable = new BX.Asteq.Catalog.AmountTable({
                element: amountTableEl,
                productId: product.getId(),
                offerId: offer?.id,
                isLazy: true,
                templateSelector: this.amountTableTemplateSelector,
            });
        }

        this.amountTable.loadStores();
    }

    moveToTab() {
        if (!this.moveToTabSelector) {
            return;
        }

        const tabEl = document.querySelector(this.moveToTabSelector);
        if(!tabEl) {
            return;
        }

        tabEl.click();
        tabEl.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    }

    onProductOfferChange(e) {
        const eventData = e.getData();
        const status = eventData.newOffer?.status;
        if (!status) {
            return;
        }
        this.setStatus(status);
    }

    onElementClick(e) {
        if (this.useStoresModal) {
            this.openStoresModal();
        }

        if (this.moveToTabSelector) {
            this.moveToTab();
        }
    }
}